import { registerSettingsCard } from '../../components/SettingsCards';
import type { ModuleRoute } from '../types';
import { EvacuatePage } from './EvacuatePage';
import { FirePanelsPage } from './FirePanelsPage';
import { ReportDetailPage } from './ReportDetailPage';
import { ReportsPage } from './ReportsPage';
import { EvacuationSettingsCard } from './SettingsCards';

registerSettingsCard('evacuation', EvacuationSettingsCard);

/**
 * Pages of this area (evacuation roll call, start/end, reports, fire panels). Owned by Phase 3 task W17; only that task edits files in this folder (W23 wires it last).
 * Exported for W23 to mount: `MemberMusterPoint` (member drawer), `EvacuationSiteCard` and `EvacuationGroupCard` (site and group pages, also registered as the `evacuation` settings card).
 */
export const routes: ModuleRoute[] = [
  { path: '/evacuation', element: <EvacuatePage />, permission: 'evacuation.view' },
  { path: '/reports/evacuations', element: <ReportsPage />, permission: 'evacuation.reports_view' },
  { path: '/reports/evacuations/:id', element: <ReportDetailPage />, permission: 'evacuation.reports_view' },
  { path: '/manage/fire-panels', element: <FirePanelsPage />, permission: 'evacuation.manage' },
];

export { MemberMusterPoint } from './MemberMusterPoint';
export type { MemberMusterPointProps } from './MemberMusterPoint';
export { EvacuationSiteCard, EvacuationGroupCard, EvacuationSettingsCard } from './SettingsCards';
